export default {
  "смешанный": "МИКС",
  "мужской": "МУЖЧИНЫ",
  "женский": "ЖЕНЩИНЫ",
  "детский": "ДЕТСКИЙ"
}
